
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/master/school/new",
      function () {
        return require("private-next-pages/master/school/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/master/school/new"])
      });
    }
  